// VehicleCount.js
import React, { useMemo } from "react";
import { MaterialReactTable } from "material-react-table";

const VehicleCount = ({ data }) => {
  // console.log("Data", data);

  // Map specific keys to custom column headers
  const columnNameMap = {
    Amc_Start_Kms: "Contract Start KMs",
    Amc_End_Kms: "Contract End KMs",
    Amc_Start_Date: "Contract Start Date",
    Amc_End_Date: "Contract End Date",
    AMC_TYPE: "AMC/FMS",
    Amc_Status: "Current Status",
  };

  // Create columns dynamically
  const columns = useMemo(() => {
    if (!data || data.length === 0) return [];

    return Object.keys(data[0]).map((key) => {
      // Use custom label if available, otherwise auto-format
      const headerText =
        columnNameMap[key] ||
        key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

      const headerLength = headerText.length;
      const dynamicSize = Math.max(150, Math.min(250, headerLength * 8 + 60));

      return {
        accessorKey: key,
        header: headerText,
        size: dynamicSize,
        minSize: 150,
        maxSize: 300,
        Header: () => (
          <div
            title={headerText}
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              lineHeight: "1.2",
              padding: "4px 0",
            }}
          >
            {headerText}
          </div>
        ),
        Cell: ({ cell }) => {
          const value = cell.getValue();

          // Format timestamp fields that contain "Date"
          if (key.toLowerCase().includes("date") && !isNaN(value)) {
            return new Date(value).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            });
          }

          return value || "-";
        },
      };
    });
  }, [data]);

  return (
    <div className="w-full flex items-center justify-center">
      <MaterialReactTable
        columns={columns}
        data={Array.isArray(data) ? data : [data]}
        enableColumnResizing
        enableColumnOrdering
        enablePagination
        enableRowNumbers
        enableStickyHeader
        enableStickyFooter
        initialState={{
          density: "compact",
          pagination: { pageSize: 10, pageIndex: 0 },
        }}
        muiTableContainerProps={{
          sx: {
            maxHeight: "500px",
            minHeight: "300px",
            width: "100%",
            overflow: "auto",
          },
        }}
        muiTablePaperProps={{
          sx: {
            width: "80%",
            maxWidth: "100%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderRadius: "8px",
          },
        }}
        muiTableProps={{
          sx: { tableLayout: "fixed", width: "100%" },
        }}
        muiTableHeadCellProps={{
          sx: {
            backgroundColor: "#f8fafc",
            fontWeight: "600",
            fontSize: "0.875rem",
            color: "#374151",
            borderBottom: "2px solid #e5e7eb",
            padding: "12px 8px",
            textAlign: "left",
            whiteSpace: "normal",
            wordWrap: "break-word",
            lineHeight: "1.3",
            minHeight: "60px",
            verticalAlign: "top",
          },
        }}
        muiTableBodyCellProps={{
          sx: {
            fontSize: "0.875rem",
            color: "#374151",
            padding: "10px 8px",
            borderBottom: "1px solid #f3f4f6",
          },
        }}
        muiTableBodyRowProps={() => ({
          sx: {
            "&:hover": { backgroundColor: "#f9fafb" },
            "& td:first-of-type": {
              fontWeight: "500",
              backgroundColor: "#f8fafc",
              position: "sticky",
              left: 0,
              zIndex: 1,
              borderRight: "1px solid #e5e7eb",
            },
          },
        })}
        muiPaginationProps={{
          color: "primary",
          shape: "rounded",
          variant: "outlined",
        }}
        displayColumnDefOptions={{
          "mrt-row-numbers": {
            header: "#",
            size: 60,
            muiTableHeadCellProps: {
              sx: {
                backgroundColor: "#f8fafc",
                fontWeight: "600",
                position: "sticky",
                left: 0,
                zIndex: 2,
                borderRight: "1px solid #e5e7eb",
              },
            },
            muiTableBodyCellProps: {
              sx: {
                backgroundColor: "#f8fafc",
                fontWeight: "500",
                position: "sticky",
                left: 0,
                zIndex: 1,
                borderRight: "1px solid #e5e7eb",
              },
            },
          },
        }}
      />
    </div>
  );
};

export default VehicleCount;
